import { createReducer } from 'typesafe-actions';
import produce from 'immer';

import * as Actions from '../actions/basisFlightAction';
import {
  FlightState,
  initFlight,
  initFlightBas,
  resweatherData
} from '../models/basisFlightModel';
import { any } from 'prop-types';

export const flightReducer = createReducer<FlightState, Actions.FlightAction>(
  initFlight
)
  .handleAction(Actions.PUBLIC_AREA_LIST.success, (state, action) =>
    produce(state, draft => {
      const { data } = action.payload;
      draft.publicAreaList = data;
    })
  )
  // .handleAction(Actions.FLIGHT_PLAN_AREA.request, (state, action) =>
  //     produce(state, draft => {
  //         const data = action.payload;
  //         draft.flightPlanArea = data;
  //     })
  // )
  // 목록
  .handleAction(Actions.FLIGHT_PLAN_LIST.success, (state, action) =>
    produce(state, draft => {
      const data = action.payload;
      draft.list = data.items;
      draft.total = data.total;
      draft.conut = data.count;
    })
  )
  // 상세
  .handleAction(Actions.FLIGHT_PLAN_DETAIL.success, (state, action) =>
    produce(state, draft => {
      const data = action.payload;
      draft.detail = data;
    })
  )
  .handleAction(Actions.FLIGHT_PLAN_DETAIL_INIT, (state, action) =>
    produce(state, draft => {
      draft.detail = initFlightBas.initDetail;
    })
  )
  // 조종사 조회
  .handleAction(Actions.FLIGHT_PLAN_PILOT_LIST.success, (state, action) =>
    produce(state, draft => {
      const data = action.payload;
      draft.pilotList = data;
    })
  )
  // 조종사 선택
  .handleAction(Actions.PILOT_SELECT, (state, action) =>
    produce(state, draft => {
      const data = action.payload;
      draft.pilotSelect = data;
    })
  )
  // 기체 조회
  .handleAction(Actions.FLIGHT_PLAN_ARCRFT_LIST.success, (state, action) =>
    produce(state, draft => {
      const data = action.payload;
      draft.arcrftList = data;
    })
  )
  // 기체 선택
  .handleAction(Actions.ARCRFT_SELECT, (state, action) =>
    produce(state, draft => {
      const data = action.payload;
      draft.arcrftSelect = data;
    })
  )
  // 조종사, 기체 선택 초기화
  .handleAction(Actions.PILOT_ARCRFT_SELECT_INIT, (state, action) =>
    produce(state, draft => {
      draft.arcrftSelect = undefined;
      draft.pilotSelect = undefined;
      // draft.areaList = undefined;
      // draft.areaCoordList = undefined;
    })
  )
  // 비행 구역 좌표 저장
  .handleAction(Actions.AREA_COORDINATE_LIST_SAVE, (state, action) =>
    produce(state, draft => {
      const data = action.payload;
      draft.areaCoordList = data;
    })
  )
  // 비행 구역 상세 저장
  .handleAction(Actions.AREA_DETAIL_LIST_SAVE, (state, action) =>
    produce(state, draft => {
      const data = action.payload;
      draft.areaList = data;
      draft.areaCoordList = data;
    })
  )
  // 비행 계획서 그룹 선택
  .handleAction(Actions.FLIGHT_PLAN_GROUP_SELECT, (state, action) =>
    produce(state, draft => {
      const data = action.payload;
      draft.selectGroup = data;
    })
  )
  // 비행 계획서 그룹 선택(목록)
  .handleAction(Actions.FLIGHT_PLAN_LIST_GROUP_SELECT, (state, action) =>
    produce(state, draft => {
      const data = action.payload;
      draft.listSelect = data;
    })
  )
  // 비행 계획서 그룹 선택(목록)
  .handleAction(Actions.FLIGHT_PLAN_APRV_GROUP_SELECT, (state, action) =>
    produce(state, draft => {
      const data = action.payload;
      draft.aprvSelect = data;
    })
  )

  // 비행 계획서 버퍼 영역 조회
  .handleAction(Actions.FLIGHT_PLAN_AREA_BUFFER_LIST.success, (state, action) =>
    produce(state, draft => {
      const data = action.payload;
      draft.areaCoordList = data;
    })
  )
  //비행구역설정 날씨 API
  .handleAction(Actions.FlightweatherAction.success, (state, action) =>
    produce(state, draft => {
      const data: resweatherData = action.payload;
      draft.weather = data;
    })
  )
  // 조종사, 기체 선택 초기화
  .handleAction(Actions.AREA_DETAIL_INIT, (state, action) =>
    produce(state, draft => {
      draft.areaList = undefined;
      draft.areaCoordList = undefined;
    })
  )
  // 비행계획서 목록(승인)
  .handleAction(Actions.FLIGHT_APRV_LIST.success, (state, action) =>
    produce(state, draft => {
      const data = action.payload;
      draft.list = data.items;
      draft.total = data.total;
      draft.conut = data.count;
    })
  )
  // 비행계획서 승인처리
  .handleAction(Actions.FLIGHT_APRV_PROC.success, (state, action) =>
    produce(state, draft => {
      const data = action.payload;
      draft.aprvProc = data;
    })
  )
  // 비행운항 스케줄
  .handleAction(Actions.FLIGHT_SCHEDULE_LIST.success, (state, action) =>
    produce(state, draft => {
      const data = action.payload;
      draft.scheduleList = data;
    })
  )
  // uam 노선 버퍼 영역 조회
  .handleAction(Actions.FLIGHT_UAM_BUFFER_LIST.success, (state, action) =>
    produce(state, draft => {
      const data = action.payload;
      draft.uamBufferList = data;
    })
  );
